import { drivers } from "./variables";
const { DELIVERY_STARTED } = drivers;

export const orderStatuses = [
  { title: "All", value: "all" },
  { title: "Created", value: "created" },
  { title: "Reserved", value: "reserved" },
  { title: "Assigned", value: "assigned" },
  { title: "Rejected", value: "rejected" },
  { title: DELIVERY_STARTED, value: "delivery_started" },
  { title: "Complete", value: "complete" },
  { title: "Paid", value: "paid" },
  // { title: "Waiting For Approval", value: "approved" },
  { title: "Approved", value: "approved" },
  { title: "Cancelled", value: "cancelled" },
];

export const changeRoleDatas = [
  { title: "Root", value: "root" },
  { title: "Admin", value: "admin" },
  { title: "BookKeeper", value: "bookkeeper" },
  { title: "Metro Manager", value: "metro_manager" },
];

export const driversStatus = [
  { title: "All", value: "all" },
  { title: "Unverified", value: "unverified" },
  { title: "Not Approved", value: "not_approved" },
  { title: "Approved", value: "approved" },
  { title: "Inactive", value: "inactive" },
  { title: "Rejected", value: "rejected" },
  // { title: "locked", value: "blocked" },
  { title: "Offboarded", value: "offboarded" },
];

export const driverReportStatus = [
  { title: "Draft", value: "draft" },
  { title: "Submitted", value: "submitted" },
  { title: "Under review", value: "under_review" },
  { title: "Needs resubmission", value: "needs_resubmission" },
  { title: "Resubmitted", value: "resubmitted" },
  { title: "Rejected", value: "rejected" },
  { title: "Waiting", value: "waiting" },
  { title: "Approved", value: "approved" },
  { title: "Conditionally approved", value: "conditionally_approved" },
  { title: "Inactive", value: "inactive" },
  { title: "Offboarded", value: "offboarded" },
  { title: "Suspended", value: "suspended" },
  { title: "Unverified", value: "unverified" },
]

export const branchStatus = [
  { title: "UNCLAIMED", value: "UNCLAIMED" },
  { title: "FAILED", value: "FAILED" },
  { title: "CREATED", value: "CREATED" },
  { title: "PENDING", value: "PENDING" },
  { title: "CLOSED", value: "CLOSED" },
  { title: "ACTIVE", value: "ACTIVE" },
]

export const shiftReportStatus = [
  { title: "Created", value: "created" },
  { title: "Reserved", value: "reserved" },
  { title: "Assigned", value: "assigned" },
  { title: "Rejected", value: "rejected" },
  { title: "Delivery started", value: "delivery_started" },
  { title: "Complete", value: "complete" },
  { title: "Paid", value: "paid" },
  // { title: "Waiting For Approval", value: "approved" },
  { title: "Approved", value: "approved" },
  { title: "Cancelled", value: "cancelled" },
]

export const driverArriva = [
  { title: "Arrival on time", value: "1" },
  { title: "Arrival late", value: "2" },
]

export const onboardStatusOption = [
  { label: "Completed", value: "true" },
  { label: "Not Completed", value: "false" },
]

export const shiftTypeOption = [
  { title: "Delivery", value: "DELIVERY" },
  { title: "Sort", value: "SORT" },
  { title: "Pick up", value: "PICKUP" },
  { title: "Contractor", value: "CONTRACTOR" },
]

export const shiftModeOption = [
  { title: "Standard", value: "Standard" },
  { title: "BT Plus", value: "BT Plus" }
]

export const payment = [
  { title: "Weekly Payment", value: "Weekly Payment" },
  { title: "Instant Payment", value: "Instant Payment" },
  { title: "Adhoc Payments", value: "AdhocPayments" },
  { title: "Shift Payment", value: "Shift Payment" },
  { title: "Payed with exceptions", value: "Exceptions Payment" },
  { title: "All Payments", value: "All Payment" },
]

export const rejectShiftScoreReason = [
  { title: "By Admin", value: "by_admin" },
  { title: "By Call", value: "by_call" },
  { title: "Not Shown", value: "not_shown" },
];

export const cancleShiftScoreReason = [
  { title: "Excess drivers", value: "excess_drivers" },
  { title: "Driver canceled", value: "driver_canceled" },
  { title: "No call, no show", value: "no_call" },
  { title: "Arrived late", value: "arrived_late" },
  { title: "Other", value: "other" },
];

export const scheduleDetails = [
  { title: "Actual", value: "actualShifts", custom_class: "bg__actual" },
  { title: "Created", value: "blocksCreated", custom_class: "bg__blocks" },
  { title: "Assigned", value: "assigned", custom_class: "bg__assigned" },
  { title: "Deficit", value: "defitieted", custom_class: "bg__defitieted" },
  {
    title: "Interested D.",
    value: "interestedDefitieted",
    custom_class: "bg__interested",
  },
];

export const arrOfTitle = [
  { label: "New", name: "new", width: "24%" },
  { label: "Shifts", name: "ws", width: "24%" },
];

export const arrOfStatusesCount = [
  { created: 0 },
  { assigned: 0 },
  { rejected: 0 },
  { delivery_started: 0 },
  { complete: 0 },
  { remain: 0 },
];

export const layoutOptionForPipelineScreen = [
  { title: "Pipeline Drivers", value: "pipeline_drivers" },
  { title: "Active Drivers", value: "active_drivers" },
  { title: "Actual Shifts", value: "actual_shifts" },
];

export const hideDriverColumn = ["Name", "Username", "Company", "Phone", "Metro", "Shifts", "Shift Last Date", "Score", "Status", "Created", "Last Login", "Date Onboard Complete", "Pipeline Stage", "Notes"]

export const hideShiftColumn = ["Metro", "Route Code", "Zones", "Route Id", "Shift Type", "Shift Mode", "Equipment", "Route Date", "Start Time", "Payout", "Driver Name", "Driver Shift Count", "Driver Phone Number", "Zones/Notes", "Internal notes", "Status", "Cancel Status"]

export const TransactionStatus = ["Completed", "Failed"];

export const CampaignStatus = [
  "Active",
  "Inactive",
  "Expired"
]

export const CampaignType = [
  "Referral",
  "Signup"
]

export const CampaignReportStatus = [
  "In Progress",
  "Failed",
  "Paid",
  "Eligible",
  "Expired"
]

export const driveDocumentType = {
  selfie: "selfie",
  driversLicense: "driversLicense",
  insurancePolicy: "insurancePolicy",
  signature: "signature",
};


export const driveFormateMetricsStatus = {
  draft: "draft",
  submitted: "submitted",
  underReview: "under_review",
  needsResubmission: "needs_resubmission",
  resubmitted: "resubmitted",
  conditionallyApproved: "conditionally_approved",
  waiting: "waiting",
  suspended: "suspended",
};


export const metroFormateForZone = {
  "St. Louis, MO": "STL",
  "Chicago, IL": "CHI",
  "Dallas/Ft. Worth, TX": "DAL",
  "Milwaukee, WI": "MIL",
  "Madison, WI": "MAD",
  "Minneapolis/St. Paul, MN": "MSP",
  "South Bend, IN": "SBE",
  "Grand Rapids, MI": "GRA",
  "Detroit, MI": "DET",
  "Indianapolis, IN": "IND",
  "Brooklyn/Queens/Long Island, NY": "NYC",
  "Cleveland, OH": "CLE",
  "Cincinnati, OH": "CIN",
  "Columbus, OH": "COL",
  "Louisville, KY": "LOU",
  "Nashville, TN": "NSH",
  "Kansas City, MO": "KAN",
  "Seattle US": "SEA",
  "Aust": "AUS",
  "New Atlanta": "ATL",
  "Illinois": "ILL",
  "California": "CAL",
  "Tyler, TX": "TYL",
  "Manhattan, NY": "MAN",
  "Chicago, by ML": "CHI",
  "St. Louis/Hazelwood, MO": "STL",
  "Surat": "SUR",
  "Honolulu": "HNL",
  "Atlanta, GA": "ATL",
  "Houston, TX": "HOU",
  "Austin, TX":"AUS",
  "Dallas-Fort Worth, TX": "DFW",
  "San Antonio, TX": "SAT",
}